<div mat-dialog-title class="bb-1 pb-3">
    <div flex fxLayout="row" class="">
        <div fxFlex>
            <div class="mat-display-1">Reserva</div>
        </div>

        <div fxFlex class="text-right">
            <mat-menu #appMenu="matMenu">
                <button mat-menu-item (click)="updateReserve(reserva.reservation_type)"><a>Editar Reserva</a></button>
                <button mat-menu-item (click)="confirmCancel()">Cancelar Reserva</button>
            </mat-menu>
            <button mat-icon-button [matMenuTriggerFor]="appMenu" *ngIf="isEditable">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
    </div>

    <div flex fxLayout="row">
        <small><b>STATUS:</b><span class="ml-1 status-{{reserva.status}}">{{ reserva.status }}</span></small>
    </div>

    <div *ngIf="reserva.cancellation.canceller" flex fxLayout="row" class="status-Cancelada">
        <small class="text-muted">por {{ reserva.cancellation.canceller.username }} el {{ reserva.cancellation.date_time | date }}: <i>"{{reserva.cancellation.reason}}"</i></small>
    </div>
</div>

<div mat-dialog-content>
    <div class="bb-1 pb-3 bt-1">
        <table class="table table-values">
            <tr>
                <td width="250">Nombre:</td>
                <td>
                    <span *ngIf="reserva.planner; else f_user">{{ reserva.planner }}</span>
                    <ng-template #f_user>{{ reserva.name }}</ng-template>
                </td>
            </tr>
            <tr>
                <td>Teléfono:</td>
                <td>{{ reserva.phone }}</td>
            </tr>
            <tr *ngIf="reserva.payment_variable">
                <td>Precio Cancha:</td>
                <td>{{ reserva.payment_variable?.amount }}</td>
            </tr>
            <tr *ngIf="reserva.payment_variable">
                <td>Seña:</td>
                <td>{{ reserva.payment_variable?.deposit  }}</td>
            </tr>
            <tr *ngIf="reserva.payment_variable">
                <td>Saldo:</td>
                <td>{{ reserva.payment_variable?.amount - reserva.payment_variable?.deposit }}</td>
            </tr>
        </table>
    </div>

    <div *ngIf="initializing; else done" class="wait flex-container-row">
        <mat-spinner color="accent" [diameter]="50"></mat-spinner>
    </div>

    <ng-template #done>
        <div flex fxLayout="row" class="bb-1 pb-3 pt-2">
            <table class="table table-values">
                <tr>
                    <td width="250">Fecha y Hora:</td>
                    <td>
                        <span>{{ reserva.start_time | date }}</span>
                        <span class="ml-3">{{ reserva.start_time | date:"HH:mm" }} - {{ reserva.end_time | date:"HH:mm" }}</span>
                    </td>
                </tr>
                <tr>
                    <td>Tamaño del partido:</td>
                    <td>{{ reserva.field_capacity }}</td>
                </tr>
                <tr>
                    <td>Tamaño del partido:</td>
                    <td>{{ reserva.field_capacity }}</td>
                </tr>
                <tr>
                    <td>Cancha asignada:</td>
                    <td>{{ reserva.field.name }}</td>
                </tr>
                <tr>
                    <td>Jugadores Confirmados:</td>
                    <td>
                        {{ guests_conf }} / {{ guests_total }}
                    </td>
                </tr>
                <tr>
                    <td>Tercer Tiempo:</td>
                    <td>{{ after_conf }}</td>
                </tr>
                <tr>
                    <td>Tipo de reserva:</td>
                    <td>{{ typeName }} </td>
                </tr>
                <tr>
                    <td>Descripcion:</td>
                    <td>{{ reserva.description }} </td>
                </tr>
            </table>
        </div>

        <div *ngFor="let match of matches" class="row bb-1 pb-2">
            <table class="table table-values">
                <tr>
                    <td width="250">Resultado:</td>
                    <td>
                        Team A: <b>{{ match.score_team_a }}</b> - Team B: <b>{{ match.score_team_b }}</b>
                    </td>
                </tr>
                <tr>
                    <td>Mejor jugador:</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Goleador:</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Rústico:</td>
                    <td></td>
                </tr>
            </table>
        </div>
    </ng-template>

</div>

<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]>Cerrar</button>
    <button mat-button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>Ok</button>
</div>